export interface roomFiltercheckbox {
  id: number;
  name: string;
}

export const RoomCategoryOptions: roomFiltercheckbox[] = [
  {
    id: 1,
    name: 'Any'
  },
  {
    id: 2,
    name: 'Deluxe King Room'
  },
  {
    id: 3,
    name: 'Deluxe Twin Room'
  },
  {
    id: 4,
    name: 'Junior King Suite'
  },
  {
    id: 5,
    name: 'One-Bedroom Deluxe Suite'
  },
  {
    id: 6,
    name: 'One-Bedroom Executive Suite'
  },
  {
    id: 7,
    name: 'Presidential Suite'
  },
  {
    id: 8,
    name: 'Club King Room'
  },
  {
    id: 9,
    name: 'Twin Room'
  },
  {
    id: 10,
    name: 'Club Twin Room'
  },
  {
    id: 11,
    name: 'Premium King Room'
  },
  {
    id: 12,
    name: 'Deluxe King Suite'
  },
  {
    id: 13,
    name: 'Executive King Suite'
  }
];

export const bedTypeOptions: roomFiltercheckbox[] = [
  {
    id: 1,
    name: 'Cribs'
  },
  {
    id: 2,
    name: 'Double beds'
  },
  {
    id: 3,
    name: 'King bed'
  },
  {
    id: 4,
    name: 'Sofa bed'
  },
  {
    id: 5,
    name: 'Twin bed'
  },
  {
    id: 6,
    name: 'Futon'
  }
];

export const amenitiesOptions: roomFiltercheckbox[] = [
  {
    id: 1,
    name: 'Wifi'
  },
  {
    id: 2,
    name: 'Washer'
  },
  {
    id: 3,
    name: 'Kitchen'
  },
  {
    id: 4,
    name: 'Dryer'
  },
  {
    id: 5,
    name: 'Air conditioning'
  },
  {
    id: 6,
    name: 'Heating'
  }
];
